import Input from "./lib/MaskedInput";

export { Input as MaskedInput };

export default Input;
